import styled from 'styled-components';
import TeaserCareer from '../../molecules/TeaserCareer';
import CTA from '../../atoms/CTA';
import { CTAIconPosition, CTATag } from '../../atoms/CTA/CTA.constants';

/**
 * @param {TeaserGrid} grid
 * @returns {string}
 */
const getTeaserWidth = (grid) => {
  switch (grid) {
    case 1:
      return '100%';
    case 2:
      return '50%';
    case 3:
      return '33.333%';
    default:
      return '33.333%';
  }
};

const TeaserCareerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  @media (${(props) => props.theme.teaserCareer.mobileSwitch}) {
    flex-direction: column;
  }
`;

const StyledCareerTeaser = styled(TeaserCareer)`
  width: ${(props) => getTeaserWidth(props.grid)};
  flex-grow: 0;
  flex-shrink: 0;
  @media (${(props) => props.theme.teaserCareer.mobileSwitch}) {
    width: 100%;
  }
`;

const StyledCTA = styled(CTA)`
  display: block;
  margin-top: 20px;
`;

const Wrapper = styled.div`
  width: 100%;
`;

/**
 * @param {CmsTeaserCareerProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CmsTeaserCareer = ({ teasers, mainLink, grid }) => {
  return (
    <Wrapper>
      <TeaserCareerContainer>
        {teasers.map((teaserProps) => (
          <StyledCareerTeaser
            key={teaserProps.headline}
            grid={grid}
            {...teaserProps}
          />
        ))}
      </TeaserCareerContainer>
      {mainLink && (
        <StyledCTA
          skin="TERTIARY"
          icon="ARROW_ANIMATION"
          iconPos={CTAIconPosition.Before}
          title={mainLink.text}
          text={mainLink.text}
          href={mainLink.url}
          type={CTATag.Link}
        />
      )}
    </Wrapper>
  );
};
export default CmsTeaserCareer;
